/* eslint-disable no-undef */
/* eslint-disable no-useless-escape */
/* eslint-disable import/prefer-default-export */
export const INVALID_EMAIL = Literals.validErrorEmail;
export const EMPTY_FIELD = Literals.validErrorEmpty;

export class Validation {
  constructor() {
    this.validationTimeout = null;
  }

  static validateEmail(value) {
    // eslint-disable-next-line max-len
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      value,
    );
  }

  static createError(input, message) {
    const parent = input.parentNode;

    if (message) {
      const err = document.createElement('div');
      err.classList.add('f-error');
      err.innerText = message;
      parent.appendChild(err);
    }
    parent.classList.add('--error');

    return false;
  }

  static createSuccess(input) {
    const parent = input.parentNode;
    parent.classList.add('--success');

    return true;
  }

  static clearStatus(input) {
    const parent = input.parentNode;
    const err = parent.querySelector('.f-error');

    parent.classList.remove('--error');
    parent.classList.remove('has-error');
    parent.classList.remove('--success');
    if (err) {
      err.remove();
    }
  }

  static validateInput(input, kind) {
    this.clearStatus(input);

    let isValid;
    switch (kind) {
      case 'email':
        isValid = this.validateEmail(input.value);
        return isValid ? this.createSuccess(input) : this.createError(input, INVALID_EMAIL);
      case 'checkbox':
        return input.checked ? this.createSuccess(input) : this.createError(input);
      default:
        isValid = input.value.length > 0;
        return isValid ? this.createSuccess(input) : this.createError(input, EMPTY_FIELD);
    }
  }

  static validateForm(event, inputs) {
    let errors = false;
    inputs.forEach((input) => {
      if (!this.validateInput(input, input.dataset.validate)) {
        event.preventDefault();
        errors = true;
      }
    });

    return errors;
  }
}
